<template>
  <Modal
    width="1226"
    title="素材选择"
    class-name="vertical-center-modal"
    v-model="state"
    loading
    :closable="false"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <!-- <Spin size="large" fix v-if="!show"></Spin> -->
    <div class="filter-box" v-if="state">
      <Form inline :label-width="40" v-if="state" @submit.native.prevent>
        <drop-autoComplete
          label="游戏"
          game
          :width="140"
          :default-option="defaultGameId"
          placeholder="请输入游戏名称"
          @on-change="handleGame"
        />
        <drop-autoComplete
          label="游戏组"
          group
          :width="140"
          :label-width="55"
          :default-option="defaultGameGroupId"
          placeholder="请输入游戏组"
          @on-change="handleGroup"
        />
        <drop-autoComplete label="上传者" member :width="120" :label-width="55" placeholder="请输入姓名" @on-change="handleOpen" />
        <drop-autoComplete label="标签" labels :width="190" :default-option="defaultLabels" placeholder="全部" @on-change="handleLabel" />
        <FormItem label="尺寸">
          <Select v-model="wide" :disabled="disabKey" style="width: 90px">
            <Option :value="1" :disabled="type === 'large'">456 X 300</Option>
            <Option :value="2">1280 X 720</Option>
            <Option :value="3">720 X 1280</Option>
            <Option :value="0" :disabled="type === 'large'">其他</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="0">
          <Input
            v-if="!disabKey"
            v-model.trim="keyword"
            placeholder="请输入素材名称"
            search
            @on-focus="focus = true"
            @on-blur="focus = false"
          />
        </FormItem>
      </Form>
    </div>
    <div class="radio-switch">
      <RadioGroup v-model="groupType" class="radio-switch-groups" @on-change="getOnline">
        <Radio v-for="(t, i) in method" :key="i" :label="t.key" :disabled="t.key !== type && t.key !== 'smart'">{{ t.value }}</Radio>
      </RadioGroup>
      <div class="switch-list" v-if="!disabKey">
        <div class="data-pick" v-if="showOrList">
          <DateRangePicker
            v-model="datetime"
            :append-to-body="false"
            :clearable="false"
            @change="handleDatetime"
            style="width: 220px"
          ></DateRangePicker>
        </div>
        <Icon :type="showOrList ? 'md-list' : 'md-apps'" size="32" color="#676767" style="cursor: pointer" @click.stop="switchList" />
      </div>
    </div>
    <!-- 数据列表 -->
    <div v-if="showOrList && !disabKey" v-loading="!show" class="image-box table-box">
      <material-tabel
        ref="materialTable"
        v-model="selection"
        :columns="columns"
        :multiple="multiple"
        :data="tableList"
        @on-refresh="getListData"
        @on-sort="sortTable"
      />
    </div>
    <!-- 智能封面 -->
    <div v-else-if="groupType === 'smart'" v-loading="!show" class="image-box">
      <div class="c-list-empty" v-if="!smartList.length">
        <Icon type="ios-filing-outline" size="100" color="#efefef" />
      </div>
      <div class="image-wrapper" v-for="(t, idx) in smartList" :key="idx" @click="selectWrap(idx)">
        <div class="image-item image-item-large">
          <img :src="t.url" :class="{ 'vertical-img': t.height > t.width }" />
          <span class="image-hover-txt">{{ t.width }}×{{ t.height }}</span>
        </div>
        <span v-if="t.check" class="image-check">
          <Icon type="md-checkmark-circle" size="24" color="#00FA9A" />
        </span>
      </div>
    </div>
    <div v-else v-loading="!show" class="image-box">
      <div class="c-list-empty" v-if="!caohuaMedia.length">
        <Icon type="ios-filing-outline" size="100" color="#efefef" />
      </div>
      <div class="image-wrapper" v-for="(item, idx) in caohuaMedia" :key="item.id || idx" @click="selectWrap(idx)">
        <template v-if="type === 'video'">
          <div class="c-item-v" v-for="t in item.items" :key="t.id">
            <div class="c-item-bg">
              <img v-if="t.height > t.width" :src="t.cover_url" alt="" />
            </div>
            <div class="image-item" @mouseenter="$set(t, '_hoverState', true)" @mouseleave="$set(t, '_hoverState', false)">
              <Row class-name="c-video-title">
                <Col span="18">
                  <p class="m-name">
                    <Tooltip :content="t.name" transfer placement="top-start">{{ t.name }}</Tooltip>
                  </p>
                  <p>{{ `${t.width} x ${t.height}` }}，{{ t.size | fileSize }}</p>
                </Col>
                <Col span="6" class-name="c-video-select">
                  <span :class="{ 'c-color-check': item.check }">选择</span>
                  <Icon
                    v-if="item.check"
                    type="md-checkmark-circle"
                    size="20"
                    color="#00FA9A"
                    style="display: inline-block; margin-top: -3px"
                  />
                  <Icon v-else type="md-checkmark-circle" size="20" color="#ddd" style="display: inline-block; margin-top: -3px" />
                </Col>
              </Row>
              <video :src="t.source_url" :controls="t._hoverState" :class="{ 'm-vertical-img': t.height > t.width }">
                您的浏览器不支持 video 标签
              </video>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="c-item-img" v-for="(t, id) in item.items" :key="id">
            <div class="c-item-bg">
              <img v-if="t.height > t.width" :src="t.cover_url" alt="" />
            </div>
            <div class="image-item" :class="{ 'image-item-logo': categroy === 8 }">
              <img :src="t.cover_url" :class="{ 'vertical-img': t.height > t.width, 'm-square-img': t.height === t.width }" />
              <Row :gutter="12" class-name="c-item-title">
                <Col span="17" class-name="c-hover-l">
                  <Tooltip :content="t.name" transfer placement="top-start"
                    ><span>{{ t.name }}</span></Tooltip
                  >
                </Col>
                <Col span="7" class-name="c-hover-r">
                  <span>{{ t.size | fileSize }}</span>
                </Col>
              </Row>
              <span class="image-hover-txt">{{ t.width }}×{{ t.height }}</span>
            </div>
            <span v-if="item.check" class="image-check">
              <Icon type="md-checkmark-circle" size="24" color="#00FA9A" />
            </span>
          </div>
        </template>
      </div>
    </div>
    <Page
      v-if="groupType !== 'smart'"
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      size="small"
      show-total
      @on-change="changePageIndex"
      class="page-index"
    />

    <template slot="footer">
      <Button type="default" @click="cancel">取消</Button>
      <Button type="primary" @click="asyncUpload">确定</Button>
    </template>
  </Modal>
</template>
<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import columns from './data/material_column'
import { setLocal, getLocal, rmLocal } from '@/common/js/api'
import { trim, isArray, formatDate, debounce } from '@/common/js/utils'
import { getCaoHuaMedia, CaohuaCoverVideo, getCaoHuaMediaData } from '@/api/common.model'
import MaterialTabel from './material-table'
import DropAutoComplete from '@/components/dropdown/'
import DateRangePicker from '@/components/date-range-picker/index.vue'

export default {
  name: 'uploader',
  components: { DropAutoComplete, DateRangePicker, MaterialTabel },
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: String
    },
    media: {
      type: [Number, String]
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    account: {
      type: [Number, String]
    },
    defaultOption: {
      type: [Number, String]
    },
    smart: {
      type: [String, Number]
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    categroy() {
      const method = this.method.filter((ret) => ret.key === this.type)
      const pop = method.pop()
      return pop.id
    },
    pageSize() {
      if (this.categroy === 3) return 3
      else if (this.categroy === 8) return 18
      else return 12
    },
    disabKey() {
      return ['smart', 'logo'].includes(this.groupType)
    }
  },
  watch: {
    gameId() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    gameGroupId() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    openId() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    wide() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    labels() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    keyword() {
      this.pageIndex = 1
      debounce(() => {
        this.sendEvent()
      }, 800)()
    },
    comDate() {
      debounce(() => {
        this.sendEvent()
      }, 800)()
    }
  },
  methods: {
    // 切换九宫格
    switchList(key) {
      this.showOrList = !this.showOrList
      this.warpstion = []
      this.sendEvent()
    },
    // 请求数据
    sendEvent() {
      if (!this.state) return
      if (this.showOrList && !this.disabKey) this.getListData()
      else this.getData()
    },
    getData() {
      const { width, height } = this.getSize()
      if (width && typeof width !== 'number') this.$Message.warning('尺寸宽度不能是非数字')
      if (height && typeof height !== 'number') this.$Message.warning('尺寸高度不能是非数字')
      const params = {
        id: this.categroy,
        gameId: this.gameId,
        gameGroupId: this.gameGroupId,
        mediaId: this.media,
        openId: this.openId,
        labels: this.labels,
        keyword: trim(this.keyword),
        width,
        height,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        lauchFlag: 1
      }
      // 查询素材与推荐封面
      this.show = false
      this.caohuaMedia = []
      if (this.smart) {
        Promise.all([getCaoHuaMedia(params), CaohuaCoverVideo({ videoId: this.smart })])
          .then((data) => {
            if (typeof data !== 'symbol') this.show = true
            if (isArray(data)) {
              const [caohuaMediaData, smartData] = data
              if (isArray(smartData)) this.smartList = smartData
              if (caohuaMediaData && isArray(caohuaMediaData.list)) {
                this.caohuaMedia = caohuaMediaData.list
                if (caohuaMediaData.page_info) this.total = caohuaMediaData.page_info.total_number
                else this.total = 0
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        getCaoHuaMedia(params).then((data) => {
          if (typeof data !== 'symbol') this.show = true
          if (data && isArray(data.list)) {
            this.caohuaMedia = data.list
            if (data.page_info) this.total = data.page_info.total_number
            else this.total = 0
          }
        })
      }
    },
    getListData() {
      const { width, height } = this.getSize()
      if (width && typeof width !== 'number') this.$Message.warning('尺寸宽度不能是非数字')
      if (height && typeof height !== 'number') this.$Message.warning('尺寸高度不能是非数字')
      const params = {
        id: this.categroy,
        gameId: this.gameId,
        gameGroupId: this.gameGroupId,
        mediaId: this.media,
        openId: this.openId,
        labels: this.labels,
        keyword: trim(this.keyword),
        width,
        height,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      // 查询素材与推荐封面
      this.show = false
      this.tableList = []
      getCaoHuaMediaData(params).then((data) => {
        if (typeof data !== 'symbol') this.show = true
        if (data && isArray(data.list)) {
          this.tableList = data.list
          if (data.page_info) this.total = data.page_info.total_number
          else this.total = 0
        }
      })
    },
    getSize() {
      let width
      let height
      switch (this.wide) {
        case 1:
          width = 456
          height = 300
          break
        case 2:
          width = 1280
          height = 720
          break
        case 3:
          width = 720
          height = 1280
          break
        default:
          width = this.width || ''
          height = this.height || ''
          break
      }
      return { width, height }
    },
    // 切换图片类型
    getOnline(val) {
      if (val !== 'smart') {
        this.pageIndex = 1
        this.sendEvent()
      }
      this.keyword = ''
    },
    // 默认初始化
    bindGetData(e) {
      if (e) {
        if (this.type === 'large') this.wide = 2
        this.setGameId()
        // 如果是视频增加智能封面
        const index = this.method.findIndex((ret) => ret.key === 'smart')
        if (index > -1) this.method.splice(index, 1)
        if (this.smart) {
          this.method.push({
            id: 5,
            key: 'smart',
            value: '推荐封面'
          })
          this.groupType = 'smart'
        } else {
          this.groupType = this.type
        }
      } else {
        this.pageIndex = 1
        this.openId = ''
        this.gameGroupId = ''
        this.gameId = -1
        this.wide = ''
        this.keyword = ''
        this.labels = []
        this.smartList = []
        this.caohuaMedia = []
        this.tableList = []
        this.selection = []
        this.warpstion = []
      }
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setGameId() {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal('select-uploader')
      const group = getLocal('select-uploader-group')
      const labels = getLocal('select-uploader-label')
      this.defaultGameId = storage && storage[account] ? storage[account] : this.defaultOption
      this.defaultGameGroupId = group && group[account] ? group[account] : this.defaultOption
      this.defaultLabels = labels && labels[account] ? labels[account] : ''
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.sendEvent()
    },
    handleGame(item) {
      this.gameId = item.id
    },
    handleGroup(item) {
      this.gameGroupId = item.id
    },
    handleOpen(item) {
      this.openId = item.id
    },
    handleLabel(item) {
      this.labels = item
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }
      this.sendEvent()
    },

    selectWrap(index) {
      const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
      if (this.multiple) {
        // 多选
        const { check, items } = data[index]
        const idx = this.warpstion.findIndex((ret) => ret.items[0].id === items[0].id)
        if (check) {
          this.$set(data[index], 'check', false)
          this.warpstion.splice(idx, 1)
        } else {
          if (idx < 0) this.warpstion.push(data[index])
          this.$set(data[index], 'check', true)
        }
      } else {
        this.caohuaMedia.forEach((ret) => {
          ret.check && this.$set(ret, 'check', false)
        })
        this.smartList.forEach((ret) => {
          ret.check && this.$set(ret, 'check', false)
        })
        this.$set(data[index], 'check', true)
      }
    },
    enterSubmit(e) {
      if (this.value && !this.focus && e.keyCode === 13) {
        const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
        const selectItem = data.filter((ret) => ret.check).pop()
        if (!selectItem) {
          this.$Message.warning('您未选择一个媒体素材或选择的素材信息有误')
          return false
        }
        this.asyncUpload()
      }
    },
    // 异步提交
    asyncUpload() {
      const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
      const selectItem = this.showOrList && !this.smart ? this.selection : this.multiple ? this.warpstion : data.filter((ret) => ret.check)
      const mapItem = (ret) => {
        const vertical = ret.width && ret.height > ret.width // 上传模式
        ret.url = ret.url || ret.source_url
        ret.msg = ''
        switch (this.groupType) {
          case 'large':
            if (vertical) {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
              if (ret.size / 1024 > 500 || ret.width < 720 || ret.height < 1280 || +(ret.width / ret.height).toFixed(2) !== 0.56) {
                ret.msg = '大图竖图，宽高比0.56，最低尺寸720*1280，大小500K以下'
              }
            } else {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_LARGE'
              if (ret.size / 1024 > 500 || ret.width < 1280 || ret.height < 720 || +(ret.width / ret.height).toFixed(2) !== 1.78) {
                ret.msg = '大图横版，宽高比1.78，最低尺寸1280*720，大小500K以下'
              }
            }
            break
          case 'video':
            if (vertical) {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
              if (ret.size / 1024 / 1024 > 100 || ret.width < 720 || ret.height < 1280 || +(ret.width / ret.height).toFixed(2) !== 0.56) {
                ret.msg = '竖版视频，宽高比0.56，视频资源支持mp4、mpeg、3gp、avi文件格式，宽高比9:16，大小不超过100M'
              }
            } else {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO'
              if (ret.size / 1024 / 1024 > 100 || ret.width < 1280 || ret.height < 720 || +(ret.width / ret.height).toFixed(2) !== 1.78) {
                ret.msg = '横版视频，宽高比1.78，视频资源支持mp4、mpeg、3gp、avi文件格式，宽高比16:9，大小不超过1000M'
              }
            }
            break
          case 'smart':
            if (vertical) {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
              if (ret.size / 1024 > 500 || ret.width < 720 || ret.height < 1280 || +(ret.width / ret.height).toFixed(2) !== 0.56) {
                ret.msg = '竖版封面图，宽高比0.56，封面图支持JPG、PNG等图片格式，宽高比9:16，大小不超过500K'
              }
            } else {
              ret.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO'
              if (ret.size / 1024 > 500 || ret.width < 1280 || ret.height < 720 || +(ret.width / ret.height).toFixed(2) !== 1.78) {
                ret.msg = '横版封面图，宽高比1.78，封面图支持JPG、PNG等图片格式，宽高比16:9，大小不超过500K'
              }
            }
            break
          case 'group':
            ret.image_mode = 'CREATIVE_IMAGE_MODE_GROUP'
            if (ret.size / 1024 > 500 || ret.width < 456 || ret.height < 300 || +(ret.width / ret.height).toFixed(2) !== 1.52) {
              ret.msg = '组图，宽高比1.52，大小500K以下，最低尺寸456*300'
            }
            break
          case 'logo':
            ret.image_mode = 'CREATIVE_IMAGE_MODE_LOGO'
            if (ret.size / 1024 > 1024 || ret.width !== 108 || ret.height !== 108) {
              ret.msg = 'LOGO图片，尺寸为108*108，支持JPG、PNG等图片格式，大小不超过1M'
            }
            break
          default:
            ret.image_mode = 'CREATIVE_IMAGE_MODE_SMALL'
            if (ret.size / 1024 > 500 || ret.width < 456 || ret.height < 300 || +(ret.width / ret.height).toFixed(2) !== 1.52) {
              ret.msg = '小图，宽高比1.52，大小500K以下，最低尺寸456*300'
            }
            break
        }
        return ret
      }
      if (selectItem.length) {
        if (this.multiple) {
          // 多选
          const uploadItem = JSON.parse(JSON.stringify(selectItem)).map((met) => {
            let { items } = JSON.parse(JSON.stringify(met))
            if (items && items.length) {
              items = items.map(mapItem)
              if (this.groupType === 'video') {
                const cover = items.map((ret) => {
                  const item = JSON.parse(JSON.stringify(ret))
                  item.url = item.cover_url
                  return item
                })
                const video = items.map((ret) => {
                  const item = JSON.parse(JSON.stringify(ret))
                  item.poster_url = item.cover_url
                  item.url = item.source_url
                  return item
                })
                items = [{ video, cover, type: this.groupType }]
              }
              met.items = items
            } else {
              // 智能封面
              met.image_mode = met.width && met.height > met.width ? 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL' : 'CREATIVE_IMAGE_MODE_VIDEO'
            }
            return met
          })
          this.$emit('on-upload', uploadItem)
        } else {
          const radioSelectItem = selectItem.pop()
          if (!radioSelectItem) return
          let { items } = JSON.parse(JSON.stringify(radioSelectItem))
          if (items && items.length) {
            // source_url cover_url
            items = items.map(mapItem)
            if (this.groupType === 'video') {
              this.$emit('on-upload', {
                video: JSON.parse(
                  JSON.stringify(
                    items.map((ret) => {
                      ret.poster_url = ret.cover_url
                      ret.url = ret.source_url
                      return ret
                    })
                  )
                ),
                cover: JSON.parse(
                  JSON.stringify(
                    items.map((ret) => {
                      ret.url = ret.cover_url
                      return ret
                    })
                  )
                ),
                type: this.groupType
              })
            } else this.$emit('on-upload', items)
          } else {
            // 智能封面
            if (radioSelectItem.width && radioSelectItem.height > radioSelectItem.width) {
              radioSelectItem.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
            } else radioSelectItem.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO'
            this.$emit('on-upload', JSON.parse(JSON.stringify([radioSelectItem])))
          }
        }
        // 记录上次成功gameId
        this.setOperatorStorage('select-uploader', this.gameId || -1)
        this.setOperatorStorage('select-uploader-group', this.gameGroupId || -1)
        if (isArray(this.labels) && this.labels.length) this.setOperatorStorage('select-uploader-label', this.labels.join(','))
        else rmLocal('select-uploader-label')
      } else {
        this.$Message.warning('您未选择一个媒体素材或选择的素材信息有误')
        this.$emit('on-upload', null)
      }
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getListData()
    },
    cancel() {
      this.$emit('input', false)
      this.$emit('on-cancel')
    }
  },
  filters: {
    fileSize(size) {
      if (typeof size !== 'number') return '0K'
      if (size > 104857) size = (size / 1048576).toFixed(2) + 'M'
      else if (size > 1000) size = (size / 1024).toFixed(2) + 'K'
      return size
    }
  },
  data() {
    // 初始化默认时间
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
    return {
      showOrList: false, // 九宫格展示 or 列表
      columns: columns,
      tableList: [],
      selection: [], // 表格选中
      warpstion: [], // 选中
      // 请求状态
      show: null,
      focus: null,

      // 分页信息
      total: 0,
      pageIndex: 1,

      // 宽高
      gameId: -1,
      gameGroupId: -1,
      openId: '',
      labels: [], // 标签
      keyword: '',
      wide: '', // 尺寸
      groupType: '',
      defaultGameId: '', // 本地存储GameId
      defaultGameGroupId: '', // 本地存储GameGroupId
      defaultLabels: '', // 本地存储Labels

      caohuaMedia: [],
      smartList: [],
      onlineVideoList: [],
      onlineImageList: [],

      method: [
        {
          id: 1,
          key: 'image',
          value: '单图'
        },
        {
          id: 1,
          key: 'large',
          value: '大图'
        },
        {
          id: 3,
          key: 'group',
          value: '三图'
        },
        {
          id: 8,
          key: 'logo',
          value: 'LOGO'
        },
        {
          id: 4,
          key: 'video',
          value: '视频'
        }
      ],
      datetime: [yesterday, yesterday]
    }
  },
  mounted() {
    // Enter Ok
    document.addEventListener('keydown', this.enterSubmit)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.enterSubmit)
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-autocomplete-suggestion,
.el-popper {
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
}

::v-deep .ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

::v-deep .el-select__tags-text {
  max-width: 84px;
}

.radio-switch {
  display: flex;
  justify-content: space-between;

  .radio-switch-groups {
    display: flex;
    align-items: center;
  }

  .switch-list {
    display: inline-block;
    min-width: 280px;
    text-align: right;

    .data-pick {
      display: inline-block;
      margin-right: 12px;
    }
  }
}

.image-box {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 420px;
  margin: 12px 0 0 0;
  padding: 6px 10px;

  .image-wrapper {
    display: inline-block;
    position: relative;

    .c-item-v,
    .c-item-img {
      display: inline-block;
      position: relative;
      margin: 0 5px 5px 5px;
      background-color: #efefef;
      overflow: hidden;
    }

    .c-item-v {
      height: 193px;
    }

    .image-check {
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      z-index: 9;
      top: 6px;
      right: 12px;
    }

    .image-item {
      width: 279px;
      height: 157px;
      position: relative;
      z-index: 2;
      text-align: center;

      img,
      video {
        width: 100%;
        height: 100%;

        &.m-square-img {
          width: auto;
        }
      }

      .c-item-title {
        position: absolute;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        right: 6px;
        line-height: 30px;
        bottom: 0;
        text-align: left;

        .c-hover-l {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .c-hover-r {
          text-align: right;
        }
      }

      .c-video-title {
        width: 100%;
        background-color: #000;
        color: #fff;
        text-align: left;
        line-height: 1;
        padding: 6px 0 6px 6px;

        p {
          margin: 0;
        }

        p.m-name {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
        }
      }

      .c-video-select {
        cursor: pointer;
        text-align: center;
        padding-top: 4px;

        .c-color-check {
          color: #00fa9a;
        }
      }

      .vertical-img {
        width: auto;
        height: 100%;
      }

      .image-hover-txt {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        position: absolute;
        top: 0px;
        left: 3px;
        color: #efefef;
        font-size: 13px;
        text-shadow: 2px 1px 1px #232323;
      }
    }

    &:hover {
      .image-hover-txt {
        opacity: 1;
      }
    }

    .image-item-large {
      width: 268px;
      height: 152px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .image-item-logo {
      width: 162px;
      height: 162px;
    }

    .c-item-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;

      img {
        width: 100%;
        height: auto;
        filter: blur(10px);
        transform: translateY(-25%);
      }
    }
  }

  .c-list-empty {
    min-height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.table-box {
  height: 420px;
  padding: 0;
}

.m-search-btn {
  float: right;
}

.page-index {
  margin-top: 12px;
  text-align: right;
}

.m-item {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.el-icon-circle-close-outline {
  cursor: pointer;
}

.c-table-list {
  height: calc(100% - 41px);
  margin-top: 8px;
}

.c-table-page {
  padding: 0 8px;
  margin-top: 8px;
  margin-bottom: 0;
  text-align: right;
}
</style>
